import { locationIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

const LocationSchema_ = z.object({
  id: locationIdFormat.schema,
  name: z.string(),
  street_1: z.string().nullable(),
  street_2: z.string().nullable(),
  city: z.string().nullable(),
  state: z.string().nullable(),
  postal_code: z.string().nullable(),
  country: z.string().nullable(),
  external_id: z.string().nullable(),
  inventoryQuantity: z.number().optional(),
  archived: z.boolean().nullish(),
});

export const LocationSchema: z.ZodType<Location> = LocationSchema_;
export interface Location extends z.infer<typeof LocationSchema_> {}

const LocationFilterSchema = z.object({
  productId: productIdFormat.schema,
  minQuantity: z.number().int().min(0),
});

export const getLocations = {
  name: "getLocations" as const,
  input: z.object({
    filters: z.array(LocationFilterSchema).max(1).optional(),
    includeArchived: z.boolean().optional(),
  }),
  output: z.object({
    locations: z.array(LocationSchema),
    defaultPoLocationId: locationIdFormat.schema.nullish(),
  }),
};
